import { useNavigate } from 'react-router-dom'
import { usePuzzles } from '../hooks'
import { useAuthStore } from '../stores/authStore'

export default function LevelSelectPage() {
  const navigate = useNavigate()
  const { signOut, user } = useAuthStore()
  const { data: puzzles, isLoading, error } = usePuzzles()

  const handleSignOut = () => {
    signOut()
    navigate('/login')
  }

  const handleSelectPuzzle = (puzzleId: string) => {
    navigate(`/game/${puzzleId}`)
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-slate-600 text-xl">Loading puzzles...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Failed to load puzzles</h2>
          <p className="text-slate-500 mb-6">{error.message}</p>
          <button
            onClick={() => window.location.reload()}
            className="px-6 py-2 bg-slate-900 text-white rounded-md font-medium hover:bg-slate-800 transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-white p-8">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-4xl font-bold text-slate-900 mb-2">Ringen</h1>
            <p className="text-slate-500">Welcome, {user?.name || user?.email}!</p>
          </div>
          <button
            onClick={handleSignOut}
            className="px-6 py-2 bg-slate-100 text-slate-700 rounded-md font-medium hover:bg-slate-200 transition-colors"
          >
            Sign Out
          </button>
        </div>

        {/* Puzzle List */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {puzzles?.map((puzzle) => (
            <button
              key={puzzle.id}
              data-puzzle-id={puzzle.id}
              onClick={() => handleSelectPuzzle(puzzle.id)}
              className="bg-white hover:bg-slate-50 rounded-lg p-6 text-left transition-colors border border-slate-200 hover:border-slate-300 shadow-sm"
            >
              <h3 className="text-xl font-bold text-slate-900 mb-2">{puzzle.name}</h3>
              {puzzle.description && (
                <p className="text-slate-500 text-sm mb-4">{puzzle.description}</p>
              )}
              <div className="flex gap-4 text-sm text-slate-400">
                <span>
                  {puzzle.width}×{puzzle.height}
                </span>
                <span>{puzzle.num_tiles} tiles</span>
                <span>{puzzle.moves.length} moves</span>
              </div>
              {puzzle.optimal_move_count && (
                <div className="mt-3 text-xs text-slate-400">
                  Optimal: {puzzle.optimal_move_count} moves
                </div>
              )}
            </button>
          ))}
        </div>

        {puzzles?.length === 0 && (
          <div className="text-center py-16">
            <p className="text-slate-400 text-lg">No puzzles available yet.</p>
          </div>
        )}
      </div>
    </div>
  )
}
